import { createLanding } from "layout/landing/landing";
import { createImagePreview } from "modules/image-preview/image-preview";
import { createClientCases } from "page-sections/section-client-cases";

createLanding();
createImagePreview(".article-case");
createClientCases();
